"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateHasNext = exports.paginationMapper = void 0;
const paginationMapper = (data) => {
    return {
        limit: data.limit,
        hasNext: data.hasNext,
    };
};
exports.paginationMapper = paginationMapper;
const calculateHasNext = (limit, total, page) => {
    return limit * page < total;
};
exports.calculateHasNext = calculateHasNext;
